import CircularProgress from '@mui/material/CircularProgress';
import appService from '../../../../service/app.service';
import useUsers from '../../../../context/UsersContext';
import colorFinder from '../../../../utils/colorFinder';
import { useRef } from 'react';

const Card = ({ data, onDragStart, statusColor, secondaryColor, loading, setRefetch, handleClick }) => {
  const columnRef = useRef(null);
  const { user } = useUsers();

  const iAmTheAddress =
    data.messages?.length > 0 &&
    data.messages?.some((message) => {
      return message.addressedTo === user?.userId && message.readAt === null;
    });

  const cannotReadAt = data.messages?.find((message) => message.addressedTo === user?.userId);

  const handleUpdateReadAt = () => {
    const findedItem = data.messages?.find((msg) => msg.lineId === data.id);
    if (iAmTheAddress && cannotReadAt.readAt === null) {
      appService.updateReadAt(findedItem.id).then(() => {
        setRefetch(true);
      });
    }
  };

  const prioColor = colorFinder(data.priority?.color);

  return (
    <div
      ref={columnRef}
      key={data.id}
      draggable
      onDragStart={(event) => onDragStart(event, data)}
      className={`px-3 relative mb-3 ${loading ? 'relative opacity-40 cursor-not-allowed' : 'cursor-pointer rounded hover:bg-kanbanHoverBackground'}`}
      style={{
        border: '1px solid #e6e6e6',
        borderTop: `7px solid ${statusColor ? statusColor?.colorCode : secondaryColor}`,
        borderRadius: '8px',
        background: iAmTheAddress ? '#fecaca' : prioColor?.colorBgCode,
      }}
      onClick={() => handleUpdateReadAt()}
      onContextMenu={(e) => {
        e.preventDefault();
        handleClick(e, { simpleTaskId: data.simpleTaskId });
      }}
    >
      {data.color && <div className="absolute inset-x-0 top-0 h-[50px] z-10" style={{ background: data.color }} />}
      {loading && (
        <div className="h-full w-full rounded z-50 left-0 absolute top-0 text-white flex items-center justify-center">
          <CircularProgress size={50} />
        </div>
      )}
      <div className="flex flex-col gap-2 my-3 text-[14px]">
        <p className="font-medium line-clamp-3">{data.simpleTaskName}</p>
        <p className="truncate">
          {[data.responsiblePerson?.userName, ...data.simpleTaskRespPersonlist.map((rp) => rp.user.userName)]
            .filter(Boolean)
            .join(', ')}
        </p>
      </div>
    </div>
  );
};

export default Card;
